export enum FindUserTypeEnum {
  sip = "sip",
  num = "num",
}

export interface UserResponse {
  user: UserModelResponse
  updatedUser: UserModelResponse
}

export interface UserModelResponse {
  id: number | undefined,
  role: number | undefined,
  medicalLicenseNumber: string | undefined;
  position: string | undefined;
  sip: string | undefined;
  PIN: number | undefined;
  name: string | undefined;
  surname: string | undefined;
  phoneNumber: string | undefined;
  dateOfBirth: string | undefined;
  isconfirmed: boolean | undefined;
  imageUrl: string | undefined;
  mutedUsers: number[] | undefined;
  hasSubscription: boolean | undefined;
  trialUsed: boolean | undefined;
  pcmToken: string | undefined;
}

export interface UserEditedRequestModel {
  medicalLicenseNumber: string;
  position: string;
  name: string;
  surname: string;
  dateOfBirth: string;
  image: string;
  sip: string;
}

export interface FindUserRequestModel {
  type: FindUserTypeEnum,
  value: string
}

export interface FindUserResponse {
  response: UserModelResponse
}
